import { defineSlotRecipe } from '@chakra-ui/react';

export const tooltipSlotRecipe = defineSlotRecipe({
  className: 'chakra-tooltip',
  slots: ['root', 'trigger', 'positioner', 'content', 'arrow', 'arrowTip'],
  base: {
    root: {
      borderRadius: 0,
    },
  },
});
